module.exports = __webpack_public_path__ + "img/wait.033b30e1.svg";